<template>
  <div data-cy="event-card-container">
    <v-card>
      <div class="d-flex flex-no-wrap">
        <div style="width: 93px; height: 125px" class="ma-2">
          <v-img
            :src="gameImage"
            width="93"
            height="125"
            class="rounded-lg"
            data-cy="event-image"
          ></v-img>
        </div>
        <div>
          <v-card-title class="text-h5" data-cy="event-name">
            {{ event.name }}
          </v-card-title>

          <v-card-subtitle data-cy="event-start-date">{{ startDate }}</v-card-subtitle>
          <v-card-subtitle data-cy="event-type-game">
            {{ eventTypeMap[event.type] }} • {{ event.videogame.name }}
          </v-card-subtitle>

          <v-card-actions>
            <v-btn
              class="ms-2"
              variant="outlined"
              append-icon="mdi-pencil"
              :to="{
                name: 'reporting',
                params: { tournamentId: tournamentId, eventId: event.id }
              }"
              data-cy="event-report-button"
            >
              Report
            </v-btn>

            <v-btn
              v-if="event.phases.length"
              class="ms-2"
              variant="outlined"
              append-icon="mdi-format-list-numbered"
              :to="{
                name: 'seeding',
                params: {
                  tournamentId: tournamentId,
                  eventId: event.id,
                  phaseId: event.phases[0].id
                }
              }"
              data-cy="event-seed-button"
            >
              Seed
            </v-btn>
          </v-card-actions>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { format } from 'date-fns'

export default {
  props: {
    event: {
      type: Object,
      required: true
    },
    tournamentId: {
      type: Number,
      required: true
    }
  },
  data: function () {
    return {
      eventTypeMap: {
        1: 'Singles',
        5: 'Teams'
      }
    }
  },
  computed: {
    startDate() {
      return format(new Date(this.event.startAt * 1000), 'MMM d, yyyy')
    },
    gameImage() {
      return this.event?.videogame?.images?.find((image) => image.type === 'primary')?.url || ''
    }
  }
}
</script>

<style></style>
